import axios from 'axios';
import { store } from "../redux/store";
import { logoutUser } from '../redux/actions';

const axiosInstance = axios.create(
  {
    // baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000',
    // baseURL: 'http://103.160.107.119:5000',
    baseURL: 'https://profita.in/api',
    // baseURL: 'https://test.profita.in/api',
    headers: {
      'Content-Type': 'application/json'
    },
    responseType: 'json'
});

// Add a request interceptor to attach the token dynamically
axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {

    if (error.response && error.response.status === 401) {
      if (error.response.data?.error?.message?.includes("jwt expired") || error.response.data?.error?.includes("jwt expired")) {
          store.dispatch(logoutUser());
          localStorage.removeItem("persist:auth");
          window.location.href = "/login"; // Redirect to login
      }
    }
    return Promise.reject(error);
  }
);


export default axiosInstance;